import { propTypes } from "@sanity/block-content-to-react";
import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './threeColumnTile.module.css';


function TCTItem(props) {

    let itemClass = styles.itemWrap+" stagger-item";

    return (
        <a href={props.item.link} className={itemClass}>
            <div className={styles.imageWrap}>
                {
                    (props.item.image) ?
                    <img src={props.item.image.image.asset.url} alt="" />
                    : ``
                }
            </div>
            <div className={styles.contentTextWrap}>
                <div className={styles.contentTitle}>
                    {props.item.title}
                </div>
                <div className={styles.description}>
                    <PortableText blocks={props.item.desc} />
                </div>
            </div>
        </a>
    );
}
  
export default TCTItem;